import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=3413ab30&scoped=true&"
import script from "./OrderView.vue?vue&type=script&lang=ts&"
export * from "./OrderView.vue?vue&type=script&lang=ts&"
import style0 from "./OrderView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderView.vue?vue&type=style&index=1&id=3413ab30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3413ab30",
  null
  
)

export default component.exports